import { css } from '@emotion/react';
import { math } from 'polished';
import { FontSize } from './vendor/_rfs.mixin';
import { BorderRadius } from './mixins/_border-radius.mixin';
import { ResetText } from './mixins/_reset-text.mixin';


export default ($) => {
  const rules = [];

  rules.push(css`
    .tooltip {
      position: absolute;
      z-index: ${$.zindexTooltip};
      display: block;
      margin: ${$.tooltipMargin};
      ${new ResetText().include($)}
      ${new FontSize($.tooltipFontSize).include($)};
      word-wrap: break-word;
      opacity: 0;

      &.show { opacity: ${$.tooltipOpacity}; }

      .arrow {
        position: absolute;
        display: block;
        width: ${$.tooltipArrowWidth};
        height: ${$.tooltipArrowHeight};

        &::before {
          position: absolute;
          content: "";
          border-color: transparent;
          border-style: solid;
        }
      }
    }
  `);

  rules.push(css`
    .bs-tooltip-top { ${tooltipStyles.top($)}; }
    .bs-tooltip-right { ${tooltipStyles.right($)}; }
    .bs-tooltip-bottom { ${tooltipStyles.bottom($)}; }
    .bs-tooltip-left { ${tooltipStyles.left($)}; }
  `);

  rules.push(css`
    .bs-tooltip-auto {
      &[x-placement^="top"] { ${tooltipStyles.top($)}; }
      &[x-placement^="right"] { ${tooltipStyles.right($)}; }
      &[x-placement^="bottom"] { ${tooltipStyles.bottom($)}; }
      &[x-placement^="left"] { ${tooltipStyles.left($)}; }
    }
  `);

  rules.push(css`
    .tooltip-inner {
      max-width: ${$.tooltipMaxWidth};
      padding: ${$.tooltipPaddingY} ${$.tooltipPaddingX};
      color: ${$.tooltipColor};
      text-align: center;
      background-color: ${$.tooltipBg};
      ${new BorderRadius($.tooltipBorderRadius).include($)}
    }
  `);

  return css(rules);
}

const tooltipStyles = {
  top: $ => css`
    padding: ${$.tooltipArrowHeight} 0;
    .arrow {
      bottom: 0;

      &::before {
        top: 0;
        border-width: ${$.tooltipArrowHeight} ${math(`${$.tooltipArrowWidth} * 0.5`)} 0;
        border-top-color: ${$.tooltipArrowColor};
      }
    }
  `,

  right: $ => css`
    padding: 0 ${$.tooltipArrowHeight};

    .arrow {
      left: 0;
      width: ${$.tooltipArrowHeight};
      height: ${$.tooltipArrowWidth};

      &::before {
        right: 0;
        border-width: ${math(`${$.tooltipArrowWidth} * 0.5`)} ${$.tooltipArrowHeight} ${math(`${$.tooltipArrowWidth} * 0.5`)} 0;
        border-right-color: ${$.tooltipArrowColor};
      }
    }
  `,

  bottom: $ => css`
    padding: ${$.tooltipArrowHeight} 0;

    .arrow {
      top: 0;

      &::before {
        bottom: 0;
        border-width: 0 ${math(`${$.tooltipArrowWidth} * 0.5`)} ${$.tooltipArrowHeight};
        border-bottom-color: ${$.tooltipArrowColor};
      }
    }
  `,

  left: $ => css`
    padding: 0 ${$.tooltipArrowHeight};

    .arrow {
      right: 0;
      width: ${$.tooltipArrowHeight};
      height: ${$.tooltipArrowWidth};

      &::before {
        left: 0;
        border-width: ${math(`${$.tooltipArrowWidth} * 0.5`)} 0 ${math(`${$.tooltipArrowWidth} * 0.5`)} ${$.tooltipArrowHeight};
        border-left-color: ${$.tooltipArrowColor};
      }
    }
  `,
}